import React, { useState } from 'react';
import type { Organization } from '@types';
import { hasSignedMsa } from '../../functions/src/common/msaSigning';
import MsaConversionModal from './MsaConversionModal';

const MsaPaymentButton: React.FC<{ organization: Organization; email: string; label?: string }> = ({ organization, email, label }) => {
    const [open, setOpen] = useState(false);
    return <>
        <button type="button" onClick={() => setOpen(true)} className="rounded-xl bg-blue-600 px-5 py-3 text-sm font-extrabold text-white hover:bg-blue-700">
            {label || (hasSignedMsa(organization) ? 'Set Up Payment' : 'Sign MSA & Set Up Payment')}
        </button>
        {open && <MsaConversionModal organization={organization} email={email} onClose={() => setOpen(false)} />}
    </>;
};

export default MsaPaymentButton;
